import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { marqueeText as fallbackMarquee } from '../../../data/announcements';
import { usePortal } from '../PortalContext';

export const MarqueeBar: React.FC = () => {
  const { t } = useTranslation();
  const { siteId, publicApi } = usePortal();
  const [text, setText] = useState(fallbackMarquee);

  useEffect(() => {
    publicApi.get(`/flashnews?siteId=${siteId}`)
      .then(res => {
        const items = res.data?.data || [];
        if (items.length > 0) {
          setText(items.map((n: any) => n.flsh_nws || n.title || '').filter(Boolean).join('  ●  '));
        }
      })
      .catch(() => {}); // keep fallback
  }, [siteId]);

  return (
  /* An ink bar rather than the old red-on-green pairing: two saturated
     signal colours side by side fought each other and fought the saffron
     band above. On graphite the red chip reads as the only urgent thing on
     the row, and the headlines get proper contrast. */
  <div className="relative flex items-stretch overflow-hidden bg-[#12161F] dark:bg-[#0d1016]">
    {/* Hairline in the accent, tying the strip to the portal theme */}
    <span
      aria-hidden="true"
      className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[var(--portal-accent)] to-transparent opacity-50"
    />

    {/* Tag-shaped chip — the chevron point makes it read as a label attached
        to the headlines rather than a second, competing bar. */}
    <div
      className="relative flex items-center gap-2 bg-gradient-to-r from-[#D32F2F] to-[#B3261E] text-white pl-4 pr-6 py-2.5 text-[11px] font-extrabold uppercase tracking-[0.09em] flex-shrink-0 whitespace-nowrap"
      style={{ clipPath: 'polygon(0 0, calc(100% - 11px) 0, 100% 50%, calc(100% - 11px) 100%, 0 100%)' }}
    >
      <span className="pulse-dot w-1.5 h-1.5 rounded-full bg-white flex-shrink-0" />
      {t('flash.label')}
    </div>

    <div className="ticker-wrap flex-1 flex items-center">
      <div className="ticker-content text-[12.5px] text-white/85 font-medium py-2.5 tracking-[0.01em]">
        {text}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{text}
      </div>
    </div>
  </div>
  );
};
